import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class DocumentGrantOfProbateMeta extends BaseEntityModel {
  parentId?: number;
  courtFileNumber?: string;
  probateGrantedDate?: string;

  constructor(model: Partial<DocumentGrantOfProbateMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.courtFileNumber = model.courtFileNumber;
    this.probateGrantedDate = model.probateGrantedDate;
  }
}
